// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__bGaYx","avatarContainer":"Profile_avatarContainer__-wwk6"};